/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
// import { FaSearch } from 'react-icons/fa'
//import { FaArrowRight } from "react-icons/fa";
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'
import { LangContext } from '../context/langContext'
import i18n from '../i18n'

const Navbar = () => {
  const { t } = useTranslation()
  const [active, setActive] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)
  const { lang, setLang } = useContext(LangContext)
  const menuActive = () => setActive(!active)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWidth(window.innerWidth)
    })

    return window.removeEventListener('resize', () => {
      console.log(window.innerWidth)
    })
  }, [])

  return (
    <React.Fragment>
      {/* search popup start*/}
      {/* <div
        className={searchShow ? 'td-search-popup active' : 'td-search-popup '}
        id="td-search-popup"
      >
        <form action="/" className="search-form">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder={t('searchPlaceholder')}
            />
          </div>
          <button type="submit" className="submit-btn">
            <FaSearch />
          </button>
        </form>
      </div>

      <button
        onClick={searchActive}
        className={searchShow ? 'body-overlay active' : 'body-overlay'}
        id="body-overlay"
      ></button> */}
      {/* ==================== Navbar Start ====================*/}
      <nav className="navbar navbar-area navbar-area-3 navbar-expand-lg">
        <div className="container nav-container custom-container">
          <div className="responsive-mobile-menu">
            <button
              onClick={menuActive}
              className={
                active
                  ? 'menu toggle-btn d-block d-lg-none open'
                  : 'menu toggle-btn d-block d-lg-none'
              }
              data-target="#itech_main_menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-left" />
              <span className="icon-right" />
            </button>
          </div>
          <div className="logo">
            <Link to="/">
              <img src={"/assets/images/" + (lang.lang != 'ar' ? "logo-text.png" : "logo-text-ar.png")} alt="img" />
            </Link>
          </div>
          {/* <div className="nav-right-part nav-right-part-mobile">
            <button className="search-bar-btn" onClick={searchActive}>
              <FaSearch />
            </button>
          </div> */}
          <div
            className={
              active
                ? 'collapse navbar-collapse sopen'
                : 'collapse navbar-collapse'
            }
            id="itech_main_menu"
          >
            <ul
              className="navbar-nav menu-open text-lg-center ps-lg-5 navbarFive"
              dir={i18n.dir()}
            >
              <li>
                <Link to="/">{t('home')}</Link>
              </li>
              <li style={{ cursor: 'pointer' }}>
                <ScrollLink
                  to="services"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={50}
                >
                  {t('services')}
                </ScrollLink>
                {/* <ul className="sub-menu">
                  <li>
                    <Link to="/service">{t('service')}</Link>
                  </li>
                  <li>
                    <Link to="/service-details">{t('service')}</Link>
                  </li>
                </ul> */}
              </li>

              <li style={{ cursor: 'pointer' }}>
                <ScrollLink
                  to="solutions"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={50}
                >
                  {t('solutions')}
                </ScrollLink>
                {/* <ul className="sub-menu">
                  <li>
                    <Link to="/team">{t('solution')}</Link>
                  </li>
                  <li>
                    <Link to="/team-details">{t('solution')}</Link>
                  </li>
                </ul> */}
              </li>
              {/* <li>
                <Link to="/about">{t("aboutus")}</Link>
              </li> */}
              {/* <li>
                <Link to="/case-study-details">Case Study Details</Link>
              </li> */}
              <li style={{ cursor: 'pointer' }}>
                <ScrollLink
                  to="#contactus"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={50}
                >
                  {t('contactus')}
                </ScrollLink>
              </li>
              {width <= 991 ? (
                <li className="lang-btns-responsive">
                  <button
                    className="text-white border-0 mx-2 rounded transition ease-in-out duration-300 lang-btn"
                    disabled={lang.lang === 'en' ? ' disabled' : ''}
                    onClick={() => {
                      setLang({ lang: 'en' })
                      i18n.changeLanguage('en')
                    }}
                  >
                    EN
                  </button>
                  <button
                    className="text-white border-0 rounded ease-in-out duration-300 transition lang-btn"
                    disabled={lang.lang === 'ar' ? ' disabled' : ''}
                    onClick={() => {
                      setLang({ lang: 'ar' })
                      i18n.changeLanguage('ar')
                    }}
                  >
                    AR
                  </button>
                  <button
                    className="text-white border-0 mx-2 rounded ease-in-out duration-300 transition lang-btn"
                    disabled={lang.lang === 'fr' ? ' disabled' : ''}
                    onClick={() => {
                      setLang({ lang: 'fr' })
                      i18n.changeLanguage('fr')
                    }}
                  >
                    FR
                  </button>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
        {width > 991 ? (
          <div className="mx-3 align-self-center lang-btns">
            <button
              className="text-white border-0 mx-2 rounded transition ease-in-out duration-300 lang-btn"
              disabled={lang.lang === 'en' ? ' disabled' : ''}
              onClick={() => {
                setLang({ lang: 'en' })
                i18n.changeLanguage('en')
              }}
            >
              EN
            </button>
            <button
              className="text-white border-0 rounded ease-in-out duration-300 transition lang-btn"
              disabled={lang.lang === 'ar' ? ' disabled' : ''}
              onClick={() => {
                setLang({ lang: 'ar' })
                i18n.changeLanguage('ar')
              }}
            >
              AR
            </button>
            <button
              className="text-white border-0 mx-2 rounded ease-in-out duration-300 transition lang-btn"
              disabled={lang.lang === 'fr' ? ' disabled' : ''}
              onClick={() => {
                setLang({ lang: 'fr' })
                i18n.changeLanguage('fr')
              }}
            >
              FR
            </button>
          </div>
        ) : null}
      </nav>
      {/* ==================== Navbar end ====================*/}
    </React.Fragment>
  )
}

export default Navbar
